'use client';

import { createContext, useContext, useMemo, type ReactNode } from 'react';

type ChatAttachmentPreviewsContextValue = {
  imagePreviewUrls: Record<string, string>;
};

const ChatAttachmentPreviewsContext = createContext<
  ChatAttachmentPreviewsContextValue | undefined
>(undefined);

type ChatAttachmentPreviewsProviderProps = {
  children: ReactNode;
  imagePreviewUrls: Record<string, string>;
};

export function ChatAttachmentPreviewsProvider({
  children,
  imagePreviewUrls,
}: ChatAttachmentPreviewsProviderProps) {
  const value = useMemo(() => ({ imagePreviewUrls }), [imagePreviewUrls]);

  return (
    <ChatAttachmentPreviewsContext.Provider value={value}>
      {children}
    </ChatAttachmentPreviewsContext.Provider>
  );
}

export function useAttachmentImagePreviewUrls(): Record<string, string> {
  return useContext(ChatAttachmentPreviewsContext)?.imagePreviewUrls ?? {};
}
